var map = {
	"./tvo-Din.png": 4953,
	"./tvo-Dinsdag.png": 9532,
	"./tvo-Don.png": 3867,
	"./tvo-Donderdag.png": 8160,
	"./tvo-Maa.png": 283,
	"./tvo-Maandag.png": 1373,
	"./tvo-Vrij.png": 195,
	"./tvo-Vrijdag.png": 107,
	"./tvo-Woe.png": 2559,
	"./tvo-Woensdag.png": 8567,
	"./tvo-Zat.png": 6657,
	"./tvo-Zaterdag.png": 3262,
	"./tvo-Zon.png": 6401,
	"./tvo-Zondag.png": 6185,
	"./tvo-overzicht.png": 2540,
	"./tvo-vannacht.png": 3137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7349;